import LocalForage from "localforage";

Object.entries(localStorage)
  .filter(([key]) => key.startsWith("CognitoIdentity"))
  .forEach(([key]) => localStorage.removeItem(key));

LocalForage.clear();
